import React, { useLayoutEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// Apply the animated theme
am4core.useTheme(am4themes_animated);

const PieChart = ({ data = [], title = "EBITDA Margin %", chartID }) => {
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    const chart = am4core.create(chartID, am4charts.PieChart);
    chart.innerRadius = am4core.percent(55);
    chart.data = data && data.length > 0 ? data : chart.data;

    chart.colors.list = [
      am4core.color("#7E57C2"),
      am4core.color("#0288D1"),
      am4core.color("#D6CEFF"),
    ];

    const series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "name"; // <-- changed here

    series.ticks.template.disabled = true;
    series.labels.template.fontSize = 14;
    series.labels.template.fill = am4core.color("#555");
    series.labels.template.radius = am4core.percent(-30);
    series.labels.template.relativeRotation = 0;

    chartRef.current = chart;

    return () => {
      chart.dispose();
    };
  }, [data, chartID]);

  return (
    <div>
      <div
        style={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "14px",
          color: "#000",
          marginBottom: "5px",
        }}
      >
        {title}
      </div>
      <div id={chartID} style={{ width: "100%", height: "240px" }} />
    </div>
  );
};

export default PieChart;
